import { useState, useEffect } from 'react';
import api, { getApiOrigin } from '../services/api';

interface ThemeImage {
  id: number;
  theme_type: string;
  image_url: string;
  is_active: boolean;
}

interface UseThemeImagesReturn {
  themeImages: Record<string, string | null>;
  isLoading: boolean;
  error: string | null;
  refreshImages: () => void;
}

export const useThemeImages = (): UseThemeImagesReturn => {
  const [themeImages, setThemeImages] = useState<Record<string, string | null>>({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadThemeImages = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      const response = await api.get('/theme-images/');
      const data = response.data;
      const imagesByTheme: Record<string, string | null> = {};

      // Processa cada imagem recebida
      if (data.theme_images && Array.isArray(data.theme_images)) {
        const origin = getApiOrigin();
        data.theme_images.forEach((img: ThemeImage) => {
          if (img.is_active && img.image_url) {
            const imageUrl = img.image_url.startsWith('http') 
              ? img.image_url 
              : `${origin}${img.image_url}`;
            imagesByTheme[img.theme_type] = imageUrl;
          }
        });
      }

      setThemeImages(imagesByTheme);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao conectar com o servidor');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadThemeImages();
  }, []);

  return {
    themeImages,
    isLoading,
    error,
    refreshImages: loadThemeImages
  };
};